export default "__VITE_ASSET__DAnIPaQW__"